import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-top-bottom, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutTopBottom"><path d="M21 21H3V20H21V21Z" fill="currentColor"/><path d="M21 18H3V6H21V18Z" fill="currentColor"/><path d="M21 4H3V3H21V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutTopBottom;
